// PayPal hosted checkout (No-Code Payment) link.
// Clicking any Buy button redirects here to PayPal's secure hosted checkout.
export const PAYPAL_PAYMENT_LINK = "https://www.paypal.com/ncp/payment/XQFMNRZAA6EFL";

export function startCheckout() {
  window.location.href = PAYPAL_PAYMENT_LINK;
}
